import React, { ReactElement } from "react";
import content from "./content";
import { useRouter } from "next/router";
import styles from "./styles.module.scss";

export default function CategoryIntro(): ReactElement {
    const { query } = useRouter();

    const item = content[query.tool as keyof typeof content];

    return (
        <section className={styles.intro}>
            <div>
                <h2>{item?.title}</h2>
                <p>{item?.description}</p>
            </div>
            <span>{item?.icon}</span>
        </section>
    );
}
